module.exports = __webpack_public_path__ + "img/grafico-default.481208db.svg";